import { toast } from "react-toastify";

const DOCUMENT_PATHS = {
  "facturas-venta": (id) => `/cuentas-por-cobrar/facturas-venta/${id}`,
  ordenes: (id) => `/cuentas-por-cobrar/ordenes/${id}`
};

const normalizeErpFrontendBase = (frontendUrl) => {
  const base = (frontendUrl || "").trim().replace(/\/$/, "");
  if (!base) return "";

  try {
    const host = new URL(base).hostname;
    if (/api\./i.test(host) || /api$/i.test(host.split(".")[0] || "")) {
      return "";
    }
  } catch {
    return base;
  }

  return base;
};

/**
 * Full SPA URL on the ERP web app for a document detail page.
 */
export const buildErpDocumentDetailUrl = (frontendUrl, type, id) => {
  const base = normalizeErpFrontendBase(frontendUrl);
  if (!base || !id || !DOCUMENT_PATHS[type]) return null;
  return `${base}${DOCUMENT_PATHS[type](id)}`;
};

export const openErpDocumentInNewTab = (frontendUrl, type, id) => {
  const url = buildErpDocumentDetailUrl(frontendUrl, type, id);

  if (!url) {
    if (!frontendUrl) {
      toast.error(
        "No hay URL de la aplicación ERP (navegador). Configúrela en Ajustes → ERP o ERP_FRONTEND_ORIGIN en el servidor."
      );
    } else {
      toast.error(
        "La URL del ERP en Ajustes no puede ser la de la API. Use la URL de la aplicación web del ERP, p. ej. https://laestacion.farmaciaslaestacion.com"
      );
    }
    return false;
  }

  window.open(url, "_blank", "noopener,noreferrer");
  return true;
};

export default buildErpDocumentDetailUrl;
